module.exports = __webpack_public_path__ + "img/stena17.460e2553.jpg";